import React from 'react';
import Reflux from 'reflux';
import {Button, Row, Col, Modal, Radio, Select, Input, message} from 'antd';
import {hashHistory, withRouter} from 'react-router';
import {DmsTab, TableView, AdvanceFormNew} from '../../components';
import {openNotice} from 'Utils';
import {objectSerial, config} from 'Utils';
import {getRankList, list2} from '../../service/thingsOrder';
import {getSubStoreList} from '../../service/product';

class CustomeOrderList extends Reflux.Component {
    constructor(props) {
        super(props);
        this.state = {
            opts: ['销售排行'],
            key: 0,
            selectedRowKeys: [],
            selectedRows: [],
            rows: [],
            total: 1,
            searchObj: {
                code: '', // 编号
                name: '',
                count: '',
                amount: '',
                orderStatus: '', // 状态
                //subStoreId: '', // 子库
                productCode: '', // 物料编号
                cusId: '',
                // cusName: '', // 客户名称
                storageId: '',
                orderDateStart: '', // 起
                orderDateEnd: '', // 止
                // shipTime: {},	// 日期筛选
                s: 10,
                p: 1
            },
            custList: '',
            objType_type: [],
            visible: false,
            button_limits_end: {},
            loading: true
        };
        this.pageChange = this.pageChange.bind(this);
        this.setFilterParam = this.setFilterParam.bind(this);
        this.advanceReset = this.advanceReset.bind(this);
        this.advanceSubmit = this.advanceSubmit.bind(this);
        this.routeLeaveHook = this.routeLeaveHook.bind(this);
    };

    /*路径跳转*/
    goView(url) {
        hashHistory.push(url);
    };

    /*筛选*/
    setFilterParam(name, value) {
        if (name === 'shipTime') {
            this.setState({
                searchObj: {
                    ...this.state.searchObj,
                    orderDateStart: value.from,
                    orderDateEnd: value.end
                }
            })
        } else {
            this.setState({searchObj: {...this.state.searchObj, [name]: value}})
        }
    };

    /*筛选重置*/
    advanceReset() {
        const self = this;
        this.setState({
            searchObj: {
                ...this.state.searchObj,
                code: '', // 编号
                storageId: '',//销售子库
                orderStatus: '', // 状态
                productCode: '', // 物料编号
                // cusName: '', // 客户名称
                cusId: '',  // 客户名称
                //subStoreId: '', //销售子库
                orderDateStart: '', // 起
                orderDateEnd: '', // 止
                p: 0,
                s: 10,
            }, loading: true
        }, () => {
            self.initData();
        })
    };

    /* 筛选确认 */
    advanceSubmit(form) {
        const self = this;
        var sObj = this.state.searchObj;
        this.setState({searchObj: {...this.state.searchObj, p: 1}, loading: true}, function () {
            self.initData();
        });
    };

    /*翻页*/
    pageChange(page, pageSize) {
        let self = this;
        this.setState({searchObj: {...this.state.searchObj, s: pageSize, p: page}, loading: true}, function () {
            self.initData();
        });
    }

    /*获取列表数据*/
    initData() {
        //let id = this.props.params.id;
        getRankList(this.state.searchObj).then(result => {
            if (result.status) {
                this.setState({
                    rows: result.data || [],
                    total: result.total || 1,
                    loading: false
                })
            } else {
                this.setState({
                    loading: false
                })
                message.error(result.message);
            }
        });
    }

    exportChange = () => {
        let _searchObj = {...this.state.searchObj};
        delete _searchObj.s;
        delete _searchObj.p;
        let url = `${config.server}/api/v1/dms/trans/order/exportRankList?${objectSerial(_searchObj)}`;
        window.open(url);
    }

    /* onSelectChange = (selectedRowKeys, selectedRows) => {
         this.setState({selectedRowKeys, selectedRows});
         // console.log()
     }*/

    //离开当前路由时，更新store
    routeLeaveHook(nextLocation) {
    }

    componentWillMount() {
        let self = this;
        getSubStoreList({
            removeFlag: 0,
            s: 1000,
            p: 1,
        }).then(res => {
            if (res.status) {
                let arr = [
                    {
                        text: '全部',
                        value: ''
                    }
                ];
                res.data.forEach(x => {
                    arr.push({
                        text: x.subStoreName,
                        value: x.id
                    })
                });
                self.setState({objType_type: arr})
            }

        });
    }

    getList2(param) {
        list2(param).then((result) => { //获取客户管理
            if (result && result.code == 200) {
                let arr = [];
                arr.push({text: '全部', value: ''});
                result.data.forEach(item => {
                    arr.push({text: item.name, value: item.id});
                })
                this.setState({custList: arr});
            } else {
                openNotice('error', '获取数据失败', result.message || '');
            }
        });
    }

    componentDidMount() {
        this.initData();
        this.getList2({p: 1, s: 10000});
        //设置离开当前路由时的钩子函数
        this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
        this.setState({
            button_limits_end: JSON.parse(window.localStorage.getItem("button_limits_end"))
        });
    }

    render() {
        var self = this;
        const {
            opts,
            key,
            rows,
            total,
            selectedRowKeys,
            searchObj,
            visible,
            button_limits_end,
            custList,
            objType_type,
            loading
        } = this.state;
        const advanceProps = {
            fileds: [
                {
                    name: 'cusId',
                    label: '客户名称',
                    text: '输入客户名称',
                    type: 'select',
                    options: custList,
                    showSearch: true,
                    defaultValue: searchObj.cusId
                },
                {
                    name: 'storageId',
                    label: '销售子库',
                    text: '选择销售子库',
                    options: objType_type,
                    defaultValue: searchObj.storageId,
                    multiple: false,//支持多选
                    type: 'select'
                },
                {
                    name: 'shipTime',//startCreatedDate, endCreatedDate
                    label: '订单日期',
                    options: [
                        {text: '开始时间'},
                        {text: '结束时间'},
                    ],
                    type: 'dateComp',
                    defaultValue: {
                        from: searchObj.orderDateStart || '',
                        end: searchObj.orderDateEnd || ''
                    }
                }
            ],
            handle: this.advanceSubmit,
            reset: this.advanceReset,
            fieldHandle: this.setFilterParam
        };
        const tableViewProps = {
            loading: loading,//更新表格数据中
            rowKey: 'id',
            pageParam: {
                total: total,
                current: searchObj.p,//当前页码
                pageSize: searchObj.s,//当前分页数
                onChange: this.pageChange
            },
            columns: [
                {
                    title: '物料编码',
                    dataIndex: 'code',
                },
                {
                    title: '物料描述',
                    dataIndex: 'name',
                },
                {
                    title: '销量',
                    dataIndex: 'count',

                },
                {
                    title: '销售金额',
                    dataIndex: 'amount',

                },
            ],
            rows,
            /*复选框功能*/
            /* rowSelection: {
                 selectedRowKeys,
                 onChange: this.onSelectChange
             }*/
        };
        return <div>
            <DmsTab options={opts} defaultKey={key}/>
            <div className="advanceForm-box">
                <div className="advanceForm-content">
                    <AdvanceFormNew {...advanceProps} />
                </div>
            </div>
            <div className="dms-table-box">
                <div className="dms-table-head">
                    <span style={{position: 'absolute', bottom: 8, right: 0}}>&emsp;共{total}个订单</span>
                    <Button style={{position: 'absolute', bottom: 8, right: 0}} icon="export"
                            onClick={this.exportChange.bind(this)}>导出</Button>
                </div>
                <TableView {...tableViewProps} />
            </div>

        </div>
    }
}
;
export default withRouter(CustomeOrderList);


// WEBPACK FOOTER //
// ./src/routes/inventory/saleRankList.js